/**
* Safely normalizes a phone number.
*
* Rules:
* - If it starts with "+" → return as-is
* - If it starts with "0" → return as-is
* - Otherwise → prepend "+"
*
* @param {any} value - Phone number input
* @returns {string} Normalized phone number
*/
export function normalizePhoneNumber(value) {
    try {
        if (value === null || value === undefined) return "";

        // Convert to string safely and trim spaces
        const number = String(value).trim();

        if (!number) return "";

        // If already starts with "+" or "0", return as-is
        if (number.startsWith("+") || number.startsWith("0")) {
            return number;
        }

        // Otherwise add "+"
        return `+${number}`;
    } catch (err) {
        console.error("normalizePhoneNumber error:", err);
        return "";
    }
}